
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"55mm","height":"336","viewBox":"0 0 55 88.9"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"colorable",attrs:{"d":"M27.5 29.712c-3.764 0-6.816 3.3-6.816 7.369h4.544c0-1.357 1.017-2.456 2.272-2.456s2.272 1.1 2.272 2.456c0 1.357-1.017 2.456-2.272 2.456h-2.726v4.913H27.5c2.517 0 4.544 2.191 4.544 4.913 0 2.721-2.027 4.912-4.544 4.912-2.517 0-4.544-2.19-4.544-4.912h-4.544c0 5.443 4.053 9.825 9.088 9.825 5.035 0 9.088-4.382 9.088-9.825 0-3.237-1.444-6.072-3.664-7.86a7.67 7.67 0 001.392-4.422c0-4.07-3.052-7.369-6.816-7.369z"}}),_c('g',{staticClass:"fg_background",attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M11.596 7.605c-1.882 0-3.408 1.65-3.408 3.685h2.272c0-.679.509-1.228 1.136-1.228.628 0 1.136.55 1.136 1.228 0 .678-.508 1.228-1.136 1.228h-1.363v2.456h1.363c1.259 0 2.272 1.096 2.272 2.456 0 1.361-1.013 2.457-2.272 2.457S9.324 18.79 9.324 17.43H7.052c0 2.722 2.027 4.913 4.544 4.913 2.517 0 4.544-2.19 4.544-4.913 0-1.618-.722-3.036-1.832-3.93a3.835 3.835 0 00.696-2.21c0-2.035-1.526-3.685-3.408-3.685zM43.404 81.295c1.882 0 3.408-1.65 3.408-3.685H44.54c0 .679-.509 1.228-1.136 1.228-.628 0-1.136-.55-1.136-1.228 0-.678.508-1.228 1.136-1.228h1.363v-2.456h-1.363c-1.259 0-2.272-1.096-2.272-2.456 0-1.361 1.013-2.457 2.272-2.457s2.272 1.096 2.272 2.457h2.272c0-2.722-2.027-4.913-4.544-4.913-2.517 0-4.544 2.19-4.544 4.913 0 1.618.722 3.036 1.832 3.93a3.835 3.835 0 00-.696 2.21c0 2.035 1.526 3.685 3.408 3.685z"}})])])
          )
        }
      }
    